<div class="tile-card" [attr.data-width]="tileWidth">
    <div class="top-content" [attr.data-width]="tileWidth">
        <div class="tile-content-wrapper">
            <div class="icon-wrapper" [ngStyle]="{ 'background-color': getStatusStyles().iconBg }">
                <!-- Image Icon -->
                @if (iconType === 'image') {
<img [src]="icon" alt="icon"
                    [ngStyle]="{ 'filter': 'brightness(0) saturate(100%)', 'color': getStatusStyles().iconColor }" />
}

                <!-- FontAwesome Icon -->
                @if (iconType === 'fontawesome') {
<i [class]="icon"
                    [ngStyle]="{ 'color': getStatusStyles().iconColor }">
                </i>
}
            </div>

            <div class="tile-content">
                <div class="tile-title">{{ title }}</div>
                <div class="tile-status">{{ statusText }}</div>
                <!-- Optional progress bar -->
                @if (state === 'executing') {
<div class="progress-bar">
                    <!-- <div class="progress"></div> -->
                    <div class="progress" [ngStyle]="{ width: progress + '%' }"></div>

                </div>
}
            </div>
        </div>

        @if (tileWidth === 'wide') {
<div class="success-content" [attr.data-width]="tileWidth">file created
            successfully</div>
}
    </div>

</div>